// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"f21af58c","990":"bbbf5743"}[chunkId] + ".chunk.js";
};